<template>
  <UIInputText
    ref="input"
    v-model="modelValue"
    :autocomplete="autocomplete"
    left-icon="search"
    :name="name"
    :label="label"
    clearable
    class="input-search"
    :controlled="controlled"
    :placeholder="placeholder"
    :sync-v-model="syncVModel"
    :compact="compact"
    type="search"
    enterkeyhint="search"
    @keydown.enter="emit('search', modelValue as string)"
    @clear="emit('search', '')"
  ></UIInputText>
</template>

<script setup lang="ts">
import type { InputTextProps } from '../../types/ui';
import type { UIInputText } from '#build/components';

defineProps<InputTextProps>();

const modelValue = defineModel<InputTextProps['modelValue']>('modelValue');

const emit = defineEmits<{
  (e: 'search', value: string): void;
}>();

const input = ref<InstanceType<typeof UIInputText> | null>(null);

defineExpose({ input });
</script>

<style scoped lang="scss">
.input-search {
  :deep() {
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }
}
</style>
